/* safeStorage — single audited gateway for browser localStorage.
 *
 * POLICY (Code Quality Report #4): localStorage in this app is ONLY for
 * non-sensitive UI preferences (prompt dismissals, locale, copy format,
 * referral attribution). Auth tokens live in httpOnly cookies (see lib/api.js)
 * and PII/case data is never persisted client-side. Any new localStorage use
 * must go through this module so audits have one place to look.
 *
 * Every call is try/catch-guarded — private browsing / disabled storage
 * degrades gracefully instead of throwing.
 */
export const safeStorage = {
  get(key, fallback = null) {
    try {
      const v = localStorage.getItem(key);
      return v === null ? fallback : v;
    } catch (err) {
      console.warn("[storage] read failed:", key, err?.message || err);
      return fallback;
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (err) {
      console.warn("[storage] write failed:", key, err?.message || err);
      return false;
    }
  },
  remove(key) {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (err) {
      console.warn("[storage] remove failed:", key, err?.message || err);
      return false;
    }
  },
  getJSON(key, fallback = null) {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (err) {
      console.warn("[storage] JSON read failed:", key, err?.message || err);
      return fallback;
    }
  },
  setJSON(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (err) {
      console.warn("[storage] JSON write failed:", key, err?.message || err);
      return false;
    }
  },
};
